module.exports = __webpack_public_path__ + "static/media/imsfooter.d3569d39.svg";